import type { ReactNode } from 'react';
import { CheckCircleFilled, ClockCircleOutlined, InboxOutlined } from '@ant-design/icons';
import type { TaskStatus } from '@/api/types';
import { useI18n } from '@/i18n/useI18n';

const MAP: Record<TaskStatus, { cls: string; icon: ReactNode }> = {
  PENDING: { cls: 'dr-pill--pending', icon: <ClockCircleOutlined aria-hidden="true" /> },
  SUBMITTED: { cls: 'dr-pill--submitted', icon: <InboxOutlined aria-hidden="true" /> },
  ACCEPTED: { cls: 'dr-pill--accepted', icon: <CheckCircleFilled aria-hidden="true" /> },
};

/** A task status pill — colour is ALWAYS paired with an icon + text (never colour alone). */
export function StatusPill({ status }: { status: TaskStatus }) {
  const { t } = useI18n();
  const m = MAP[status];
  return (
    <span className={`dr-pill ${m.cls}`}>
      {m.icon}
      {t(`taskStatus.${status}`)}
    </span>
  );
}
